import { Component, HostBinding, Input } from "@angular/core";
import { DialogAdapter } from "common/dialog/dialog-adapter";

export class MessageDetails {
	header: string = "";
	list: string[] = [];
}

@Component({
	selector: "stages-warn",
	templateUrl: "./warn.component.html",
	styleUrls: ["./warn.component.scss"],
})
export class WarnComponent {
	@HostBinding("class.confirm") customClass = true;

	messageDetailsExpanded = true;

	constructor(private dialog: DialogAdapter) {}

	@Input()
	keys!: {
		title?: string;
		message: string;
		messageDetails?: MessageDetails;
		ok: string;
	};

	ok(): void {
		this.dialog.close("ok");
	}

	toggleList(): void {
		this.messageDetailsExpanded = !this.messageDetailsExpanded;
	}
}
